export class GlobalFilters {
  sic: string = '';
  shift: string = '';
  region: string = '';
  planDate: Date;
}
